import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { LuCopy, LuRefreshCcw } from 'react-icons/lu';
import { DateTime } from 'luxon';

import { Button } from '_components/_core';

import { PixQrCodeModal } from '../..';

import { Value } from '../../../../../styles';
import { BoxText } from '../styles';

function InvoicePaymentPix({ invoice, isRefreshing, onRefreshPayment }) {
  const { metadata } = invoice;
  const { pix_payload } = metadata;

  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const isCodeExpired = useMemo(() => {
    const expireDate = invoice.metadata.pix_expire_date;

    if (!expireDate) {
      return false;
    }

    return DateTime.fromFormat(expireDate, 'yyyy-MM-dd HH:mm:ss') < DateTime.now();
  }, [invoice]);

  const handleCopy = async e => {
    e.preventDefault();
    e.stopPropagation();

    await navigator.clipboard.writeText(pix_payload);
  };

  const formatAsaasPixDate = useCallback(date => {
    const datePart = date.split(' ')[0];
    const [year, month, day] = datePart.split('-');

    return `${day}/${month}/${year} às ${date.split(' ')[1]}`;
  }, []);

  if (isCodeExpired) {
    return (
      <>
        <PixQrCodeModal
          isVisible={isModalVisible}
          onModalToggle={() => setIsModalVisible(!isModalVisible)}
          invoice={invoice}
        />
        <Row>
          <Col>
            <div>
              <BoxText>
                O código Pix expirou, gere um novo código para efetuar o pagamento.
              </BoxText>
            </div>
            <Button
              variant="default"
              className="d-flex justify-content-center align-items-center mt-3"
              onClick={onRefreshPayment}
              isLoading={isRefreshing}
              disabled={isRefreshing}
            >
              <LuRefreshCcw className="mr-2" />
              Gerar novo QR Code
            </Button>
          </Col>
        </Row>
      </>
    );
  }

  return (
    <Row>
      <Col xs={12} md={6}>
        <Value>Pix</Value>
        <div className="d-flex align-items-center mt-2">
          <img
            width={200}
            height={200}
            src={`data:image/jpeg;base64, ${invoice.metadata.pix_base64}`}
            alt="QR Code pix"
          />
          <p className="w-50">
            Acesse seu APP de pagamentos e faça a leitura do QR Code ao lado para efetuar
            o pagamento de forma rápida e segura.
          </p>
        </div>
        <div className="text-warning">
          <small>
            QR Code válido até {formatAsaasPixDate(invoice.metadata.pix_expire_date)}
          </small>
        </div>
      </Col>
      <Col
        className="d-flex align-items-center"
        style={{
          borderLeft: '1px solid #f1f1f4',
        }}
        xs={12}
        md={6}
      >
        <div>
          <Value>Código Pix copia e cola</Value>
          <div className="d-flex align-items-center">
            <p
              className="mt-3"
              style={{
                wordBreak: 'break-all',
              }}
            >
              {invoice.metadata.pix_payload}
            </p>
          </div>
          <Button
            onClick={handleCopy}
            className="d-flex justify-content-center align-items-center"
          >
            <LuCopy className="mr-2" />
            Copiar
          </Button>
        </div>
      </Col>
    </Row>
  );
}

InvoicePaymentPix.defaultProps = {
  invoice: null,
};

InvoicePaymentPix.propTypes = {
  invoice: PropTypes.object,
  onSetInvoice: PropTypes.func.isRequired,
  onRefreshPaymentData: PropTypes.func.isRequired,
};

export default InvoicePaymentPix;
